<template>
	<div>
		<Drawer v-model="showModal" width="550px;" title="装箱列表">
			<div>
				<Menu mode="horizontal" :active-name="packingType" @on-select="changePackingTypeCallback">
					<MenuItem :name="1" style="width: 249px;text-align: center">
						<b>散件装箱</b>
					</MenuItem>
					<MenuItem :name="2" style="width: 249px;text-align: center">
						<b>整件装箱</b>
					</MenuItem>
				</Menu>
			</div>
			<Spin fix v-if="loading">
				<Icon type="ios-loading" size=18 class="demo-spin-icon-load"/>
				<div>Loading</div>
			</Spin>
			<div v-for="(item,index) of orderBoxList" :key="index" v-if="!loading">
				<div class="line1">
					<div class="checkBox">
						<Checkbox v-model="item._checked" :true-value="1" :false-value="0" @on-change="selectBoxCallback"/>
					</div>
					<div class="left2">
						<a style="color: #4d5669" @click="changeBoxDetailCallback(item)">
							<Icon :type="item._extend==1?'ios-arrow-up':'ios-arrow-down'" size="44"
							      style="line-height: 54px;"/>
						</a>
					</div>
					<div class="boxTitle">
						<b>{{item.box_no_title}}</b>
					</div>
					<div class="button">
						<Button type="success" ghost @click="printPackingBox(item)">打印</Button>
					</div>
				</div>
				<div class="line2" v-if="item._extend==1">
					<Divider style="margin-top: -10px;"/>
					<div class="childConent" v-for="(goods,goodsIndex) of item.boxGoodsList" :key="goodsIndex">
						<div class="goodsTitle">
							<span>{{goods.productName}}</span>
						</div>
						<div class="childButton">
							<Poptip placement="left" :width="500" transfer>
								<div slot="content" v-if="showSelectBoxModal">
									<div style="padding: 10px 10px 30px 10px;" v-if="canJoinBoxList.length">
										<Button type="primary" :ghost="selectIds.includes(boxItem.box_id)?false:true"
										        v-for="(boxItem,boxIndex) of canJoinBoxList"
										        :key="boxIndex" size="large" style="margin-right: 10px;margin-top:10px;"
										        @click="selectJoinBoxCallback(boxItem)">
											{{boxItem.box_no_title}}
										</Button>
									</div>
									<div style="padding: 20px;text-align: center" v-else>
										暂无可加入的箱子
									</div>
									<div>
										<Button size="large" icon="md-checkmark-circle" long type="primary" :disabled="!selectIds.length"
										        @click="doChangeBox(goods)">
											<span v-if="selectIds.length">确认</span>
											<span v-else>请选择要加入的箱号</span>
										</Button>
									</div>
								</div>
								<Button type="success" ghost @click="queryCanJoinBoxList(goods)" v-if="packingType==1">切换</Button>
							</Poptip>
						</div>
						<div class="childButton">
							<Button type="error" ghost @click="doCancelBox(item,goods)">移除</Button>
						</div>
					</div>
				</div>
				<Divider/>
			</div>

			<div style="height: 70px;"></div>
			<div class="demo-drawer-footer">
				<Row type="flex" :gutter="10">
					<Col span="10">
						<Button size="large" long @click="selectAllBoxCallback(selectBoxIds.length?0:1)">
							<span v-if="!selectBoxIds.length">全选</span>
							<span v-else>取消所选</span>（已选{{selectBoxIds.length}}箱）
						</Button>
					</Col>
					<Col span="14">
						<Button type="primary" size="large" long :disabled="!selectBoxIds.length" @click="printPackingBoxBatch">
							批量打印箱签
						</Button>
					</Col>
				</Row>

			</div>
		</Drawer>
		<globalPrint ref="globalPrint"/>
	</div>
</template>

<script>
	const CONSTANT = require("../../../common/const");
	import {queryBoxListByOrder, queryCanJoinBoxList, doChangeBox, doCancelBox} from "@/api/sorting/packingBox";

	export default {
		name: "orderBoxList",
		props: {},
		data() {
			return {
				CONSTANT,
				showModal: false,
				packingType: 1,
				// 订单箱子
				orderBoxList: [],
				orderId: null,
				// 所选箱子
				selectBoxIds: [],
				// 展开的箱子
				extendBoxIds: [0],
				// 可加入箱子列表
				canJoinBoxList: [],
				// 选择加入的箱子
				selectIds: [],
				showSelectBoxModal: false,
				loading: false,
			}
		},
		methods: {
			// 展示窗口
			showOrderBoxModal(data) {
				this.showModal = true;
				this.orderId = data.orderId;
				this.packingType = 1;
				this.selectBoxIds = [];
				this.extendBoxIds = [0];
				this.queryBoxListByOrder();
			},
			// 切换装箱类型
			changePackingTypeCallback(event) {
				this.packingType = event;
				this.selectBoxIds = [];
				this.queryBoxListByOrder();
			},
			// 切换箱子明细
			changeBoxDetailCallback(event) {
				if (event._extend) {
					event._extend = 0;
					if (this.extendBoxIds.includes(event.box_id)) {
						this.extendBoxIds.splice(this.extendBoxIds.indexOf(event.box_id), 1);
					}
				} else {
					event._extend = 1;
					if (!this.extendBoxIds.includes(event.box_id)) {
						this.extendBoxIds.push(event.box_id);
					}
				}
			},
			// 选择箱子回调
			selectBoxCallback() {
				this.selectBoxIds = [];
				for (let i = 0; i < this.orderBoxList.length; i++) {
					if (this.orderBoxList[i]._checked)
						this.selectBoxIds.push(this.orderBoxList[i].box_id);
				}
			},
			// 选择箱子回调
			selectJoinBoxCallback(item) {
				if (this.selectIds.includes(item.box_id)) {
					this.selectIds.splice(this.selectIds.indexOf(item.box_id), 1);
				} else {
					this.selectIds.push(item.box_id);
				}
			},
			// 选择箱子回调 0取消选择 1全选
			selectAllBoxCallback(type) {
				this.selectBoxIds = [];
				for (let i = 0; i < this.orderBoxList.length; i++) {
					this.orderBoxList[i]._checked = type;
					if (type)
						this.selectBoxIds.push(this.orderBoxList[i].box_id);
				}
			},
			// 查询箱子记录
			queryBoxListByOrder() {
				if (!this.orderId) return;
				this.loading = true;
				queryBoxListByOrder({orderId: this.orderId, packingType: this.packingType}).then(data => {
					if (data.data.code === 1200) {
						let orderBoxList = data.data.data.datas;
						for (let i = 0; i < orderBoxList.length; i++) {
							if (this.extendBoxIds.includes(orderBoxList[i].box_id)) {
								orderBoxList[i]._extend = 1;
							}
						}
						this.orderBoxList = orderBoxList;
						this.loading = false;
					}
				}).catch(err => {
					this.$Message.error(err);
				});
			},
			// 查询箱子商品记录明细
			/*queryBoxListDetailByOrder(event) {
				queryBoxListDetailByOrder({orderId: this.orderId, boxNo: event.box_id}).then(data => {
					if (data.data.code === 1200) {
						let orderBoxDetailList = data.data.data.datas;
						event.boxGoodsList = orderBoxDetailList;
					}
				}).catch(err => {
					this.$Message.error(err);
				});
			},*/
			// 查询可加入箱子
			queryCanJoinBoxList(event) {
				this.selectIds = [];
				let packIds = [event.packId];
				this.showSelectBoxModal = true;
				queryCanJoinBoxList({packIds, orderId: this.orderId}).then(data => {
					if (data.data.code === 1200) {
						this.canJoinBoxList = data.data.data;
					}
				}).catch(err => {
					this.$Message.error(err);
				});
			},
			// 调箱
			doChangeBox(event) {
				let param = {packId: event.packId, changeBoxIds: this.selectIds, boxRecordId: event.boxRecordId, orderId: this.orderId};
				doChangeBox(param).then(data => {
					if (data.data.code === 1200) {
						this.showSelectBoxModal = false;
						this.queryBoxListByOrder();
						this.submitChangeData([event.packId]);
					}
				}).catch(err => {
					this.$Message.error(err);
				});
			},
			// 删除箱子
			doCancelBox(boxInfo, event) {
				this.$Modal.confirm({
					title: "提示",
					content: "确认移除 " + boxInfo.box_no_title + "内商品【 " + event.productName + "】",
					onOk: () => {
						let param = {cancelBoxType: 2, deleteIds: [event.boxRecordId], packId: event.packId, cancelAll: false};
						this.buttonLoading = true;
						doCancelBox(param).then(data => {
							if (data.data.code == 1200) {
								this.showSelectBoxModal = false;
								this.queryBoxListByOrder();
								this.submitChangeData([event.packId]);
							} else {
								this.$Message.error(data.data.msg)
							}
							this.buttonLoading = false;
						});
					},
					onCancel: () => {
					}
				});
			},
			// 打印箱签
			printPackingBox(item) {
				this.$refs.globalPrint.printPackingBox([{orderId: this.orderId, boxId: item.box_id}]);
			},
			// 打印箱签
			printPackingBoxBatch() {
				let printDatas = [];
				for (let i = 0; i < this.orderBoxList.length; i++) {
					if (this.orderBoxList[i]._checked)
						printDatas.push({orderId: this.orderId, boxId: this.orderBoxList[i].box_id});
				}
				this.$refs.globalPrint.printPackingBox(printDatas);
			},
			// 提交数据
			submitChangeData(packIds) {
				this.$emit('reciveChangeData', {packIds});
				// return console.log(Number(this.currentNumber))
			},
		},
		mounted() {
		},
		watch: {}
	}
</script>

<style scoped lang="less">
	.ivu-divider-horizontal {
		margin: 0px;
	}

	.line1 {
		display: flex;
		padding: 10px;

		.checkBox {
			width: 40px;
			line-height: 50px;
		}

		.left2 {
			width: 52px;
		}

		.boxTitle {
			width: 320px;
			line-height: 50px;
		}

		.button {
			width: 64px;
			line-height: 50px;
		}
	}

	.line2 {
		background-color: #f8f8f9;

		.childConent {
			display: flex;
			padding: 0 0 5px 55px;

			.goodsTitle {
				width: 292px;
				line-height: 50px;
			}

			.childButton {
				width: 75px;
				line-height: 50px;
				float: right;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/boxManage/orderBoxList.vue